import React, { useState , useEffect}  from 'react';
import { MdOutlineCancel } from 'react-icons/md';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import { useStateContext } from '../../contexts/ContextProvider';
import { FooterPages } from '..';
import DownloadButton from "../../components/IconButtons/DownloadButton";
import {formatDate} from '../../formatters/date';
import { fetchUser } from '../../utils/fetchUser';
import { crearMensaje, notificarUsuario } from '../../services/Util';
import { getMensajeRol } from '../../services/UsuarioSucursal';
import { updateAsignacionFinaliza } from '../../services/Asignaciones';

import { Toaster,toast } from 'react-hot-toast';
import DataTable from 'react-data-table-component';
import ButtonToolBar from '../ButtonToolBar';
import { uploadFile , downloadFile } from '../../services/filesTools';
// import { de } from 'date-fns/locale';

const initialState = {
  idEquipo: '',
  nombreEquipo:'',
  cantidad:0,
  capacidadEquipo:'',
  permanencia:0,
  comentarios:'',
  anno: '',
  patente: '',
  serie: '',
};

const AutorizarAsignacion = ({vecinoData, linea, onChangeVecino}) => {
  const { isClicked, handleClick, setIsClicked } = useStateContext();
  const [formDataDisplay, setFormDataDisplay] = useState({});
  const [formData, setFormData] = useState(initialState);
  const [solicitudData, setSolicitudData] = useState([]);
  const [asignadosData, setAsignadosData] = useState([]);
  const [obsAdm,setObsAdm] = useState('');
  
  const inputClass = "text-[11px] border border-gray-300 p-1.5 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-400";

  const [buttonsToolAp, setButtonsToolAp] = useState([
    { name: 'rechazar', label: 'Cancelar', disabled: false },
    { name: 'aprobar2', label: 'Personal BNovus', disabled: false },
    { name: 'aprobar', label: 'Aprobar', disabled: false },
  ]);

    const disableButtonToolAp = (buttonName) => {
    setButtonsToolAp((prevButtons) =>
      prevButtons.map((button) =>
        button.name === buttonName ? { ...button, disabled: true } : button
      )
    );
  };

  const userInfo = fetchUser();

  useEffect(() => {
    if(vecinoData) {
    //  console.log('linea A BUSCAR ', linea);
    //  console.log('TODOS LOS ASIGNADOS ', vecinoData.detalleAsignados);

      const equipo = vecinoData.detalleEquipos.find((item) => item.lin === linea);
      setFormData({
        idEquipo: equipo.idMaquina,
        nombreEquipo: equipo.nombreMaquina,
        cantidad: equipo.cantidad,
        capacidadEquipo: equipo.capacidad,
        permanencia: equipo.permanencia,
        comentarios: equipo.comentario,
        anno: equipo.anno,
        patente: equipo.patente || '',
        serie: equipo.serie || ''
      });
      setFormDataDisplay(vecinoData);
      setSolicitudData(vecinoData.detalleEquipos);
      const opciones = vecinoData.detalleAsignados.filter((item) => item.linequipo === linea);
    //  console.log('OPCIONES ASIGNADOS ', opciones);
      setAsignadosData(opciones);
      if (vecinoData.estadoSolicitud === 'Aprobado'){
        disableButtonToolAp('aprobar');
      }
      
    } 
  }, [vecinoData]);

const navegaBNovus = async () => {
    try {
      // La URL a la que quieres navegar
      const url = "https://login.bnovus.cl/Seleccion/PorProyectov2/Proyecto/ListaProyectostarja.aspx";
      
      // Abre la URL en una nueva pestaña ('_blank')
      // 'noopener,noreferrer' es una buena práctica de seguridad
      window.open(url, '_blank', 'noopener,noreferrer');

    } catch (error) {
      console.log(error);
      // Asegúrate de tener 'toast' importado si usas una librería de notificaciones
      toast.error('Problemas al acceder a BNovus, contacte a Soporte.');
    }
  };

  const devolverAprobacion = async () =>{
    try {
        onChangeVecino('REFRESH');
        setIsClicked( !isClicked.nuevoAutoriza );
      } catch (error) {
        console.log(error);
        toast.error('Problemas al guardar asignación, contacte a Soporte.');
        return;
      }
  }

  const AprobarAsignacion = async () =>{
    if (asignadosData.length === 0){
      toast.error('Debe asignar al menos un Equipo.');
      return;      
    };
    try {
        let flag = false;
        let countFlag = 0;
       // console.log(' INICIO VALIDACION ');
        asignadosData.forEach((detalle) => {
          if ( detalle.seleccionado === 'SI') {
             flag = true;
             countFlag++
          };
        });

        if ( !flag ) {
          toast.error('Debe seleccionar al menos un Equipo para autorizar.'); 
          return;
        }
        if ( countFlag > formData.cantidad  ) {
          toast.error('Solo puede seleccionar un Equipo para autorizar.');
          return;
        }

        for (const detalle of asignadosData) {
          if (detalle.seleccionado === 'SI') {
            const allDataAsignacion = {
                _id: vecinoData._id,
                empresa: userInfo.empresa,
                idSolicitud: vecinoData.idSolicitud,
                idasignaciones: vecinoData._id,
                idMandante: vecinoData.idMandante,
                idEquipo: formData.idEquipo,
                idCentro: vecinoData.idCentro,
                idAutorizador: userInfo.usuario,
                fechaAutorizacion: Date.now(),
                obsAdm: obsAdm,
                lineaSol: linea,
                lineaAsig: detalle.lin
            };
            await updateAsignacionFinaliza(allDataAsignacion);
          }
        }

        const mUser = await getMensajeRol('Logística');
        const dataMensaje = {
        numeroSolicitud: vecinoData.numeroSolicitud };
        if (mUser){
          mUser.forEach(element => {     
            let mensaje = crearMensaje(element._id, 'equipoAutorizado', dataMensaje);
            notificarUsuario(JSON.stringify(mensaje));
          });
        }

        onChangeVecino('REFRESH');
        setIsClicked( !isClicked.nuevoAutoriza );
      } catch (error) {
        console.log(error);
        toast.error('Problemas al guardar asignación, contacte a Soporte.');
        return;
      }
  }

  
  const handleGetDocu = async (row) => {

      if (row.idArchivo) {
        await downloadFile(row.idArchivo, row.nombreArchivo || "documento.pdf");
      } else {
        toast.error('No hay archivo asociado a este equipo.');
      }

  };

  const toggleSelectedEquipo = (dato) => {
    setAsignadosData((prevData) =>
      prevData.map((row) =>
        row.lin === dato.lin
          ? { ...row, seleccionado: row.seleccionado === 'SI' ? 'NO' : 'SI' }
          : row
      )
    );
    
  };

  const handleButtonToolBarClick = (buttonName) => {
    if (buttonName === 'aprobar') {
      AprobarAsignacion();
    } else if (buttonName === 'aprobar2') {
      navegaBNovus();
    } else if (buttonName === 'rechazar') {
      devolverAprobacion();
    }
  };

  const handleChange = (e) =>{
    setObsAdm(e.target.value);
  };

const customStyles = {
  table: {
    style: {
      backgroundColor: 'white',
      borderRadius: '8px',
    },
  },
  head: {
    style: {
      fontSize: '14px',
      fontWeight: 'bold',
      color: '#2F336A',
      backgroundColor: '#F2F5FE',
      borderBottom: '1px solid #D9E1F2',
    },
  },
  headRow: {
    style: {
      minHeight: '48px',
      borderBottomWidth: '1px',
    },
  },
  headCells: {
    style: {
      paddingLeft: '12px',
      paddingRight: '12px',
      whiteSpace: 'nowrap',
    },
  },
  rows: {
    style: {
      fontSize: '13px',
      backgroundColor: 'white',
      minHeight: '52px',
      borderBottom: '1px solid #F3F4F6',
      transition: 'background-color 0.2s ease-in-out',
    },
    highlightOnHoverStyle: {
      backgroundColor: '#F9FAFB',
      borderBottomColor: '#E5E7EB',
      outline: 'none',
    },
  },
  cells: {
    style: {
      paddingLeft: '12px',
      paddingRight: '12px',
    },
  },
};

  const columnsMaq = [
    {
      name: "",
      width: "50px",
      cell: (row) => (
        <div
          onClick={(e) => {
            e.stopPropagation(); // Evita que el clic afecte la selección completa de la fila
            toggleSelectedEquipo(row);
          }}
          className="cursor-pointer"
        >
          {row.seleccionado === 'SI' ? (
            <FaCheckCircle color="green" size={24} />

          ) : (
            <FaTimesCircle color="gray" size={24} />
          )}
        </div>
      ),
    },
    {
      name: '',
      width: '40px',
      cell: (row) => ( <DownloadButton onClick={() => handleGetDocu(row)} /> )
    },
    {
      name: 'Lin',
      width: '40px',
      selector: row => row.lin,
      sortable: true
    },
    {
      name: 'Equipo',
      width: '100px',
      selector: row => row.codigoEquipo,
      sortable: true
    },
    {
      name: 'Capacidad',
      width: '120px',
      selector: row => row.capacidad,
      sortable: true
    },
    {
      name: 'Marca',
      width: '120px',
      selector: row => row.marca,
      sortable: true
    },
    {
      name: 'Modelo',
      width: '100px',
      selector: row => row.modelo,
      sortable: true
    },
    {
      name: 'Año',
      width: '100px',
      selector: row => row.anno,
      sortable: true
    },
    {
      name: 'Horometro',
      width: '130px',
      selector: row => row.horometro,
      sortable: true
    },
    {
      name: 'Kilometraje',
      width: '130px',
      selector: row => row.kilometraje,
      sortable: true
    },
    {
      name: 'Horas mínimas',
      width: '150px',
      selector: row => row.horasminimas,
      sortable: true
    },
    {
      name: 'Tarifa Estudio',
      width: '150px',
      selector: row => row.tarifaEstudio,
      sortable: true
    },
    // {
    //   name: 'Porcentaje',
    //   width: '120px',
    //   selector: row => row.porcentaje,
    //   sortable: true
    // },
    {
      name: 'Tarifa All Inclusive',
      width: '180px',
      selector: row => row.tarifaAllInclusive,
      sortable: true
    },
    {
      name: 'Fecha Entrega',
      width: '150px',
      selector: row => formatDate(row.fechaEntrega),
      sortable: true
    },
    {
      name: 'Responsable',
      width: '130px',
      selector: row => row.responsable,
      sortable: true
    },
    {
      name: 'Proveedor',
      width: '120px',
      selector: row => row.nombreProveedor,
      sortable: true
    },
    {
      name: 'Archivo',
      width: '110px',
      selector: row => row.nombreArchivo,
      sortable: true
    }
  ];

  return (
    <form  onSubmit={AprobarAsignacion} >
     <div className="bg-half-transparent w-full fixed nav-item top-0 right-0">
     <div className="overflow-y-scroll float-right h-screen duration-1000 ease-in-out dark:text-gray-200 transition-all dark:bg-[#484B52] bg-gray-100  w-full md:w-full p-8">

        <div className="flex justify-between items-center px-4 py-2 border-b border-gray-200 bg-white rounded-t-md shadow-sm">
            <div className="flex items-center gap-2">
              <div className="w-2.5 h-2.5 rounded-full bg-blue-500 animate-pulse" />
              <p className="text-gray-800 font-semibold text-base md:text-lg">
              Autorizar Equipos
              </p>
            </div>

            <button
              type="button"
              onClick={() => setIsClicked(!isClicked.nuevoAutoriza)}
              className="text-gray-400 hover:text-red-500 transition-colors duration-150 p-2 rounded-full hover:bg-gray-100"
              aria-label="Cerrar"
            >
              <MdOutlineCancel className="text-xl md:text-2xl" />
            </button>
          </div>

        <div className="bg-gray-200 p-6 rounded-lg shadow-lg">
        <div className="grid grid-cols-2 md:grid-cols-10 gap-4" >

          <div className="flex flex-col items-start">      
            <label className="text-xs font-semibold mb-1">Fecha en Obra</label>
            <input
              className={inputClass}
              type="text"
              placeholder=""
              name="fechaEnObra"
              value= {(() => {
                const detalle = formDataDisplay.detalleEquipos?.find(d => d.lin === linea);
                return detalle?.fechaEnObra ? formatDate(detalle.fechaEnObra) : '-';
              })()}
              disabled
            />
          </div>
          <div className="flex flex-col">
            <label className="text-xs font-semibold mb-1">Centro Costo</label>
            <input
              className={inputClass}
              type="text"
              placeholder=""
              name="codigoCentro"
              value= {formDataDisplay.codigoCentro}
              disabled
            />
          </div>
          <div className="col-span-3">
            <div className="flex flex-col">
                <label className="text-xs font-semibold mb-1">Proyecto</label>
                <input
                  className={inputClass}
                  type="text"
                  placeholder=""
                  name="nombreProyecto"
                  value= {formDataDisplay.nombreProyecto}
                  disabled
                />
            </div>
          </div>  
          <div className="flex flex-col">
            <label className="text-xs font-semibold mb-1">Ubicación</label>
            <input
                className={inputClass}
                type="text"
                placeholder=""
                name="ubicacion"
                value= {formDataDisplay.ubicacion}
                disabled
              />
          </div>
                
          <div className="col-span-3">
            <div className="flex flex-col">
                <label className="text-xs font-semibold mb-1">Observación</label>
                <input
                    className={inputClass}
                    type="text"
                    placeholder=""
                    name="observacionAd"
                    value= {formDataDisplay.observacionAd}
                    disabled
                  />
            </div> 
          </div>   
              <div className="flex flex-col ">
                <label className="text-xs font-semibold mb-1">Estado Solicitud</label>
                <input
                className={inputClass}
                type="text"
                placeholder=""
                name="estadoSolicitud"
                value= {formDataDisplay.estadoSolicitud}
                disabled
                />
              </div>  
            </div>    
        </div>   
        <div className="mt-5 space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-1 gap-8">
          <div className=" bg-gray-200 p-6 rounded-lg shadow-lg">
            <div className="grid grid-cols-1 md:grid-cols-7 gap-4" >
              <div className="col-span-2">
                <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Equipo</label>
                  <input
                    className={inputClass}
                    type="text"
                    placeholder=""
                    name="nombreEquipo"
                    value= {formData.nombreEquipo}
                    disabled
                  />
                </div>
              </div>
              <div className="flex flex-col">
                <label className="text-xs font-semibold mb-1">Cantidad</label>
                <input
                  className={inputClass}
                  type="text"
                  placeholder=""
                  name="cantidad"
                  value= {formData.cantidad}
                  disabled
                />
              </div>
              <div className="flex flex-col">
                <label className="text-xs font-semibold mb-1">Capacidad</label>
                <input
                  className={inputClass}
                  type="text"
                  placeholder=""
                  name="capacidadEquipo"
                  value= {formData.capacidadEquipo}
                  disabled
                />
              </div>
              <div className="flex flex-col">
                <label className="text-xs font-semibold mb-1">Permanencia</label>
                <input
                  className={inputClass}
                  type="text"
                  placeholder=""
                  name="permanencia"
                  value= {formData.permanencia}
                  disabled
                />
              </div>
              <div className="col-span-2">
                <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Comentario</label>
                  <input
                    className={inputClass}
                    type="text"
                    placeholder=""
                    name="comentarios"
                    value= {formData.comentarios}
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>      
        </div>

        <div className="grid grid-cols-1 md:grid-cols-1 gap-8">
          <div className=" bg-white p-6 rounded-lg shadow-lg">
            <div className="grid grid-cols-1 md:grid-cols-1 gap-4" >
              <div className="flex flex-col">
                <DataTable
                  columns={columnsMaq}
                  data={asignadosData}
                  highlightOnHover
                  pagination={true}
                  striped
                  className="border border-gray-300 rounded-lg shadow-sm"
                  noHeader={true}
                  selectableRowsHighlight
                  customStyles={customStyles}
                  noDataComponent={'No hay Maquinas seleccionadas'}
                />
              </div>
            </div>      
          </div>
        </div>


              <div className="bg-white p-6 rounded-lg shadow-lg items-end">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className="flex flex-col mt-4">
                    <label className="text-xs font-semibold mb-1">Observación</label>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder=""
                        name="obsAdm"
                        value= {obsAdm}
                        onChange={handleChange}
                      />
                  </div>


                </div>
                <div className="flex flex-col mt-4">
                  <ButtonToolBar buttons={buttonsToolAp} onButtonClick={handleButtonToolBarClick} />
                </div>
              </div>    
              <Toaster
                position="top-right"
                toastOptions={{
                  style: {
                    zIndex: 9999,
                  },
                }}
              />       
              <FooterPages />  
          </div>

        </div>
      </div>

    </form>
    
  );
};

export default AutorizarAsignacion;